<div class="page-content-wrapper">
  <div class="card rounded-3 border-1 shadow">
    <ApplicationComponent />
    <div class="text-end mt-4 mb-3 me-3">
      <button
        class="btn bg-green btn-sm text-xxs fw-bold rounded-small me-2"
        @click="approve_application"
      >
        Approve
      </button>
    </div>
  </div>
</div>
